export function cacheWithForm(formPropertyName: string, ...keys: string[]) {
	return function (
		_target: any,          // eslint-disable-next-line @typescript-eslint/no-unused-vars
		propertyKey: string,
		descriptor: PropertyDescriptor
	): PropertyDescriptor {
		const originalMethod = descriptor.value;
		const cacheProperty = Symbol(`__cache_${propertyKey}`);

		descriptor.value = function (...args: any[]) {
			const self = this as any;

			if (!self[cacheProperty]) {
				self[cacheProperty] = {
					cacheValue: null,
					cacheKeys: {} as Record<string, any>
				};
			}

			const cache = self[cacheProperty];
			const form = (self as any)[formPropertyName];
			const formValue = form?.getRawValue ? form.getRawValue() : {};

			let cacheIsValid = true;
			for (const key of keys) {
				const newVal = formValue?.[key];
				if ((cache.cacheKeys as Record<string, any>)[key] !== newVal) {
					cacheIsValid = false;
					break;
				}
			}

			if (!cacheIsValid) {
				cache.cacheValue = originalMethod.apply(self, args);
				for (const key of keys) {
					(cache.cacheKeys as Record<string, any>)[key] = formValue?.[key];
				}
			}

			return cache.cacheValue;
		};

		return descriptor;
	};
}
